module.exports = __webpack_public_path__ + "static/img/loungehakuba.1619cf8b.png";